import axios from 'axios';

// WordPress blog API
const API = axios.create({
  baseURL: 'http://blog.getinfo.aju.br/wp-json/wp/v2/',
});

// GLPI API
const GLPI_API = axios.create({
  baseURL: 'https://servicedesk.getinfo.net.br/apirest.php',
  headers: {
    'Content-Type': 'application/json',
    'App-Token': 'JH9lHz2wbof1dhIPBPTaiEmXB4jjOJ9Ox48Ygnqd',
  },
});

export { GLPI_API };
export default API;
